    export class konstanten {
        public static BASE_URL: string = window.location.origin;
    }

    export interface CallbackFunctions { (arg: any, ...args: any[]): void };

